import React from 'react';
import styled from 'styled-components/macro';
import { CompleteIntermediateShelf } from '../../../../../lib/modelBuilder/entities/CompleteIntermediateShelf';
import StyledDimensionValue from '../../../styles/StyledDimensionValue';

interface Props {
  interShelf: CompleteIntermediateShelf;
}

const InterShelfSchemaDimensions = ({ interShelf }: Props) => (
  <StyledInterShelfSchema>
    <div className="absolute h-full w-full flex items-center justify-start">
      <StyledDimensionValue small>
        {interShelf.height / 10}
      </StyledDimensionValue>
    </div>
  </StyledInterShelfSchema>
);

const StyledInterShelfSchema = styled.div`
  grid-row-end: span 1;
  position: relative;
  border-top: 2px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
`;

export default InterShelfSchemaDimensions;
